module.exports = __webpack_public_path__ + "img/oaknest-4.0c24d643.jpeg";